package app

import app.properties.Document
import app.properties.DocumentType
import app.properties.getTargetValue
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.onChangeFunction
import react.*
import react.dom.*

interface PersonalInfoProps : RProps {
    var documentType: Array<DocumentType>?
    var document: MutableList<Document>
    var touch: Boolean
}
interface PersonalInfoState : RState {
    var document: MutableList<Document>
}

class PersonalFormInfo(props: PersonalInfoProps) : RComponent<PersonalInfoProps,PersonalInfoState>(props) {

    init {
        state.document = props.document
    }

    val ducomentTypeList = props.documentType

    override fun componentDidMount() {
        setDataPicker()
    }

    override fun componentDidUpdate(prevProps: PersonalInfoProps, prevState: PersonalInfoState, snapshot: Any) {
        setDataPicker()
    }

    fun setDataPicker() {
        val datepicker = js("jQuery('#giveDateDatepicker0').datepicker({ format: 'dd/mm/yyyy', autoclose: true, });")

        datepicker.on("change", fun() {
            setState {
                document[0].docuemntGiveTime = datepicker.datepicker("getFormattedDate")
            }
        })

        val datepicker1 = js("jQuery('#giveDateDatepicker1').datepicker({ format: 'dd/mm/yyyy', autoclose: true, });")

        datepicker1.on("change", fun() {
            setState {
                document[1].docuemntGiveTime = datepicker1.datepicker("getFormattedDate")
            }
        })
    }

    override fun RBuilder.render() {
        div("row") {
            div("col") {
                label { +"Փաստաթղթեր" }
            }
        }
        div("row") {
            ducomentTypeList?.forEachIndexed { index, documentType ->
                div("col-lg") {
                    input(InputType.checkBox) {
                        attrs {
                            id = "documentType${index}"
                            jsStyle {
                                margin = "0 10px"
                            }
                            this["checked"] = state.document.any { it.documentType?.id == documentType.id }
                            onChangeFunction = { event ->
                                val valueOfChecbox = getTargetValue(event)

                                if(valueOfChecbox.toBoolean()) {
                                    setState {
                                        document.add(Document(documentType = documentType))
                                    }
                                } else {
                                    setState {
                                        document.removeAll { it.documentType?.name == documentType.name }
                                    }
                                }

                            }
                        }
                    }
                    label {
                        attrs {
                            this["htmlFor"] = "documentType${index}"
                            jsStyle {
                                if((state.document.isEmpty() || !state.document.all { it.isValid() }) && props.touch) {
                                    color = "red"
                                }
                            }
                        }
                        +documentType.name
                    }
                }
            }
        }

        state.document.forEachIndexed { index, creditDocument ->
            div("row") {
                div("col-lg col-md-12") {
                    label { +"Փաստաթղթի համար" }
                    div (classes = "form-control") {
                        +creditDocument.documentType?.name!!
                    }
                }
                div("col-lg col-md-12") {
                    label { +"Փաստաթղթի համար" }
                    input(classes = "form-control") {

                        attrs {

                            val documentValidation = if(creditDocument.documentType?.name != "Անձնագիր") {

                                var isInt = true
                                try {
                                    creditDocument.documentNumber.toInt()
                                } catch (e: Exception) {
                                    isInt = false
                                }

                                (creditDocument.documentNumber.length != 9 || !isInt) && props.touch
                            } else {
                                val r = Regex("^([A-Z]{2}[0-9]{7})+$")
                                !r.containsMatchIn(creditDocument.documentNumber) && props.touch
                            }

                            if(documentValidation) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }

                        attrs.value = creditDocument.documentNumber
                        attrs.onChangeFunction = {
                            val documentNumber = getTargetValue(it)
                            setState {
                                creditDocument.documentNumber = documentNumber
                            }
                        }
                    }
                }
                div("col-lg col-md-12") {
                    label { +"Տրման ամսաթիվը/օր, ամիս, տարեթիվ/" }
                    input(classes = "form-control") {
                        attrs {
                            if(creditDocument.docuemntGiveTime == "" && props.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }
                        attrs.id = "giveDateDatepicker${index}"
                        attrs.value = creditDocument.docuemntGiveTime
                        attrs.onChangeFunction = {
                            val createDate = getTargetValue(it)
                            setState {
                                creditDocument.docuemntGiveTime = createDate
                            }
                        }
                    }
                }
            }
            div("row") {
                div("col-lg-4 col-md-12") {
                    label { +"Ում կողմից" }
                    input(classes = "form-control", type = InputType.number) {
                        attrs {
                            if(creditDocument.whoGiveDocument.length != 3 && props.touch) {
                                jsStyle {
                                    border = "1px solid red"
                                }
                            }
                        }
                        attrs.value = creditDocument.whoGiveDocument
                        attrs.onChangeFunction = {
                            val whoGiveDocument = getTargetValue(it)
                            setState {
                                val whoGiveDocumentToInt = try {
                                    whoGiveDocument.toInt()
                                } catch (e: Exception) {
                                    0
                                }
                                creditDocument.whoGiveDocument = if(whoGiveDocumentToInt < 0) "0" else whoGiveDocument
                            }
                        }
                    }
                }
            }
            hr {  }
        }
    }
}

fun RBuilder.personalForm(documentType: Array<DocumentType>?, document: MutableList<Document>, touch: Boolean) = child(PersonalFormInfo::class) {
    attrs.documentType = documentType
    attrs.document = document
    attrs.touch = touch
}